<template>
	<div class="benefit-detail-page">
		<div class="benefit-page-breadcrumb">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ name: 'MyBenefits' }">我的权益</el-breadcrumb-item>
				<el-breadcrumb-item :to="remainingRoute">剩余权益</el-breadcrumb-item>
				<el-breadcrumb-item>权益使用记录</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<benefit-order-summary :order="summaryOrder"></benefit-order-summary>

		<div v-loading="loading" class="benefit-detail-section">
			<div class="detail-section-heading">
				<strong>权益使用记录</strong>
				<span>记录当前账号同类权益的使用时间</span>
			</div>
			<el-table :data="usageRecords" border empty-text="暂无同类权益使用记录">
				<el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
				<el-table-column label="权益板块" min-width="150" align="center">
					<template slot-scope="scope">
						<span class="module-tag">{{ scope.row.module }}</span>
					</template>
				</el-table-column>
				<el-table-column label="权益类型" min-width="180" align="center">
					<template slot-scope="scope">
						<span class="benefit-type-name">{{ scope.row.type }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="useTime" label="使用时间" min-width="220" align="center"></el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import BenefitOrderSummary from './components/BenefitOrderSummary'
	import { queryMyGoodsBenefitDetail } from '@/api/mall'

	export default {
		name: 'MyBenefitUsageRecord',
		components: { BenefitOrderSummary },
		data() {
			return {
				loading: false,
				usageRecords: []
			}
		},
		computed: {
			currentOrder() {
				return {
					orderId: this.$route.query.orderId,
					orderNo: this.$route.query.orderNo || '-',
					orderTime: this.$route.query.orderTime || '-',
					shipmentTime: this.$route.query.shipmentTime || '-'
				}
			},
			currentProduct() {
				return {
					id: this.$route.query.productId,
					productName: this.$route.query.productName || '商品权益',
					productDesc: this.$route.query.productDesc || '',
					quantity: Number(this.$route.query.quantity || 1),
					status: this.$route.query.status || 'pending',
					benefitCount: Number(this.$route.query.benefitCount || 0)
				}
			},
			// 订单摘要仅呈现本次查看权益的商品。
			summaryOrder() {
				return {
					...this.currentOrder,
					products: [this.currentProduct],
					benefitCount: this.currentProduct.benefitCount
				}
			},
			// 面包屑返回剩余权益时保留当前订单上下文。
			remainingRoute() {
				return {
					name: 'MyBenefitRemaining',
					query: { ...this.$route.query }
				}
			}
		},
		created() {
			this.loadUsageRecords()
		},
		methods: {
			async loadUsageRecords() {
				if (!this.$route.query.orderId || !this.$route.query.productId) return
				this.loading = true
				try {
					const response = await queryMyGoodsBenefitDetail({
						orderId: this.$route.query.orderId,
						sourceGoodsId: this.$route.query.productId
					})
					const data = response.data || {}
					const records = Array.isArray(data.useRecords) ? data.useRecords : []
					this.usageRecords = records.map(item => ({
						module: item.memberBenefitGroup || '-',
						type: item.memberBenefitName || item.memberBenefit || '-',
						useTime: item.operateTime || item.createTime || '-'
					}))
				} finally {
					this.loading = false
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import './benefit-detail.scss';
</style>
